import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Button,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Select,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Tooltip,
} from "@material-ui/core";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import { useForm } from "../../../../hooks/useForm";
import AutoCompleteDiagnostico from "../../UI/AutoCompleteDiagnostico";
import { InformacionDocumentacion } from "./InformacionDocumentacion";
import { startAlerta } from "../../../../actions/ui/alertas";
import {
  getSectoresInternacion,
  getTiposSolicitudes,
  postSolicitud,
  putCancelarSolicitud,
  updateSolicitud,
  updateSolicitudValues,
} from "../../../../actions/autorizaciones/Autorizaciones";
import SeguimientoSolicitud from "../SeguimientoSolicitud";
import { AUTORIZACIONES_SOLICITUDES_ESTADOS, TIPOS_AUTORIZACIONES } from "../../../../utils/constants";
import { AlertFinalizadoStepper } from "../../../stepper/AlertFinalizadoStepper";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { AUTORIZACIONES_PERMISOS } from "../../../../utils/permisos";
import { ModalNotas } from "./ModalNotas";
import { LocalHospitalSharp } from '@material-ui/icons';
import { TraerEvolucionesAfiliadoFecha } from '../../../../actions/hce/hceActions';
import { ModalEvolucionesProblemas } from '../../../HCE/ListadoPacientes/ModalHce/ModalEvolucionesProblemas';

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const InformacionMenu = (props) => {
  const { disabled, desdeBandejaSurge = false } = props;
  const dispatch = useDispatch();
  const { tiposSolicitudes = [], solicitudSeleccionada = {},
    sectoresInternacion, solicitudSeleccionadaSeguimiento,
    estadoSolicitudes, practicas = [] } = useSelector(
      (state) => state.autorizaciones
    );
  const { dni, permisos: permisosUser } = useSelector(state => state.auth)
  const [faltaDocumentacion, setFaltaDocumentacion] = useState(false);
  const [tituloModal, setTituloModal] = useState("");
  const [confirmarCancelar, setConfirmarCancelar] = useState(false);
  const [openModalNotaCancelar, setOpenModalNotaCancelar] = useState(false);
  const [openValidacionDni, setOpenValidacionDni] = useState(false);
  const [openModalProblema, setOpenModalProblema] = useState(false);
  const [dniUser, setDniUser] = useState('');

  let solicitudDefault = {
    idTipoSolicitud: "",
    diagnostico: null,
    fechaPrescripcion: "",
    fechaProgramada: "",
    fechaIngreso: "",
    fechaEgreso: "",
    idMotivoInternacion: "",
    idSector: "",
    conInternacion: false,
    telefono: "",
    celular: "",
  };

  const [
    formValues,
    handleInputChange,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
    ,
  ] = useForm(
    !!solicitudSeleccionada ? solicitudSeleccionada : solicitudDefault
  );

  const {
    idEstadoSolicitud,
    idTipoSolicitud,
    diagnostico,
    fechaPrescripcion,
    fechaProgramada,
    fechaIngreso,
    fechaEgreso,
    idMotivoInternacion,
    idSector,
    conInternacion,
    idSolicitud,
    telefono,
    celular,
  } = formValues;

  useEffect(() => {
    if (idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION)
      dispatch(getSectoresInternacion());
  }, [dispatch, idTipoSolicitud]);

  useEffect(() => {
    dispatch(getTiposSolicitudes());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      updateSolicitudValues({
        diagnostico,
        idDiagnostico: diagnostico ? diagnostico.idProblema : null,
      })
    );
  }, [diagnostico]);

  useEffect(() => {
    dispatch(
      updateSolicitudValues({
        idTipoSolicitud,
      })
    );
  }, [idTipoSolicitud]);

  useEffect(() => {
    //FechaPrescripcion
    ValidatorForm.addValidationRule("isAfterToday", (value) => {
      if (moment(value).isValid() && moment(value).isAfter(moment(), "day")) {
        return false;
      }
      return true;
    });

    //FechaProgramada
    ValidatorForm.addValidationRule("isBeforeFechaPrescripcion", (value) => {
      if (
        moment(value).isValid() &&
        moment(value).isBefore(moment(fechaPrescripcion), "day")
      ) {
        return false;
      }
      return true;
    });
  });

  const [conInternacionValue, setConInternacionValue] = useState(
    conInternacion ? "internacion" : "ambulatorio"
  );

  const idTipoSolicitudPractica = tiposSolicitudes.filter(
    (solicitud) => solicitud.descripcionTipo === "Prácticas"
  )[0]?.idTipo;

  const practicaElegida = tiposSolicitudes.filter(
    (solicitud) => solicitud.idTipo === idTipoSolicitud
  )[0];

  const practicaLabo = practicas.find(s => s.autorizada && s.turno);

  const onSubmitHandler = () => {
    if (!confirmarCancelar) {
      console.log("entro??");
      if (!diagnostico) {
        dispatch(startAlerta(`Falta el Diagnostico.`, "warning"));
      } else if (faltaDocumentacion && idTipoSolicitud !== TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION) {
        dispatch(startAlerta(`Documentación Incompleta.`, "warning"));
      } else {
        dispatch(postSolicitud(solicitudSeleccionada));
      }
    }
  };

  const handleSendConfirmarCancelar = () => {
    //NOTA
    if (dni !== parseInt(dniUser)) {
      dispatch(startAlerta("El DNI ingresado no coincide con el del usuario logueado", "error"));
    } else {
      setTituloModal("Agregar nota")
      setOpenModalNotaCancelar(true);
    }
  }

  const resetValues = () => {
    setDniUser('');
    setOpenValidacionDni(false);
    setConfirmarCancelar(false);
  }

  return (
    <ValidatorForm onSubmit={onSubmitHandler} style={{ margin: "1rem 3rem" }}>
      {openModalNotaCancelar &&
        <ModalNotas
          open={openModalNotaCancelar}
          close={() => {
            setOpenModalNotaCancelar(false);
          }}
          guardar={(saveNote) => {
            dispatch(
              putCancelarSolicitud(
                idSolicitud,
                props.onCloseModalAuditar,
                true,
                resetValues,
                props.filtros,
                null,
                null,
                () => saveNote()
              )
            )
            //resetValues();
          }}
          desdeIngresoSolicitud={props.desdeIngresoSolicitud}
          idSolicitud={idSolicitud}
          disabled={false}
          titulo={tituloModal}
          privada={true}
          filtros={props.filtros}
        />

      }
      {/*idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS
       &&*/ (idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA ||
          estadoSolicitudes === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUTORIZADA) &&
        validarSoloUnPermiso(permisosUser, AUTORIZACIONES_PERMISOS.CANCELAR_SOLICITUD_AUTORIZADA)
        && !props.seguimiento
        &&
        <Grid item xs={12}>
          <AlertFinalizadoStepper
            open={confirmarCancelar}
            pregunta={"Cancelar Solicitud"}
            dialogText={"Esta seguro de cancelar la Solicitud con Nro de Orden " + solicitudSeleccionada?.idSolicitud + "?"}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Confirmar"}
            handleClose={() => setConfirmarCancelar(false)}
            handleSend={() => setOpenValidacionDni(true)}
            filtros={props.filtros}
          />
          <AlertFinalizadoStepper
            open={openValidacionDni}
            pregunta={"Validación datos"}
            dialogText={`Ingrese el DNI del Usuario loqueado para confirmar la eliminación de la solicitud`}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Confirmar"}
            showTextBox={true}
            textBoxValue={dniUser}
            setTextBoxValue={setDniUser}
            textBoxLabel={'Nro. Doc. Usuario'}
            handleClose={() => resetValues()}
            handleSend={() => handleSendConfirmarCancelar()}
            filtros={props.filtros}
          />

          <div style={{ textAlign: "center", /*marginTop: "2.5rem"*/ }}>

            <Button
              variant="contained"
              color="primary"
              onClick={() => setConfirmarCancelar(true)}
              disabled={desdeBandejaSurge === true ? true : false}
            >
              Cancelar Autorizacion
            </Button>
          </div>
        </Grid>
      }
      {solicitudSeleccionada?.idPresupuesto !== null && <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
              >
                Presupuesto N°:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                {solicitudSeleccionada?.idPresupuesto}
              </TableCell>
            </Box>
          </TableRow>
        </TableBody>
      </Table>}
      {solicitudSeleccionada?.idSolicitudDenunciaInt !== null && <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
              >
                Denuncia de Int. N°:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                {solicitudSeleccionada?.idSolicitudDenunciaInt}
              </TableCell>
            </Box>
          </TableRow>
        </TableBody>
      </Table>}
      {solicitudSeleccionada?.valorCierre !== null && <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
              >
                Valor Cierre:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                {solicitudSeleccionada?.valorCierre}
              </TableCell>
            </Box>
          </TableRow>
        </TableBody>
      </Table>}
      <Table style={{ width: "80%", margin: "auto" }}>
        <TableBody>
          <TableRow>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "20%", whiteSpace: "nowrap" }}
              >
                Tipo de Orden:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                {Array.isArray(tiposSolicitudes) && tiposSolicitudes?.length > 0 && (
                  <Select
                    style={{ width: "300px" }}
                    name="idTipoSolicitud"
                    value={idTipoSolicitud}
                    onChange={(e) => {
                      handleInputChange(e);
                      dispatch(
                        updateSolicitud("idTipoSolicitud", e.target.value)
                      );
                    }}
                    disabled={true}
                  >
                    {Array.isArray(tiposSolicitudes) &&
                      tiposSolicitudes?.length > 0 &&
                      tiposSolicitudes.map((tipoSolicitud) => (
                        <MenuItem
                          key={tipoSolicitud.idTipo}
                          value={tipoSolicitud.idTipo}
                        >
                          {tipoSolicitud.descripcionTipo}
                        </MenuItem>
                      ))}
                  </Select>
                )}
              </TableCell>
            </Box>
          </TableRow>
        </TableBody>
      </Table>
      {(idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION ||
        idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA) &&
        <Table style={{ width: "80%", margin: "auto" }}>
          <TableBody>
            <TableRow>
              {disabled
                ?
                <SeguimientoSolicitud
                  mouseEvent
                  label={"Seguimiento:"}
                  seguimiento={solicitudSeleccionadaSeguimiento}
                />
                :
                <SeguimientoSolicitud
                  label={"Seguimiento:"}
                />
              }
            </TableRow>
          </TableBody>
        </Table>
      }      
      <Table
        style={{ width: "80%", margin: "auto" }}
      >
        <TableBody>
          <TableRow>
            <TableCell
              style={{
                borderBottom: "0",
                fontSize: "1rem",
                verticalAlign: "bottom",
                position: "relative",
                bottom: "2px",
              }}
            >
              Diagnostico:
            </TableCell>
            <TableCell
              style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
            >
              <AutoCompleteDiagnostico
                disabled={disabled}
                autoCompleteValue={diagnostico}
                onChangeHandler={(value) => {
                  setearValor("diagnostico", value);
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      {idTipoSolicitud === TIPOS_AUTORIZACIONES.LABORATORIO &&
        <Table style={{ width: "80%", margin: "auto" }}>
          <TableBody>
            {practicaLabo &&
              <TableRow>
                <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                  Realizada:
                </TableCell>
                <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                  {`${new Date(practicaLabo?.turno?.fecha)
                    .toLocaleString("es", optionsfecha)} / ${practicaLabo?.turno?.hora}`}
                </TableCell>
                <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                  Centro Médico:
                </TableCell>
                <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                  {`${practicaLabo?.turno?.centroMedico?.descripcionCentro}`}
                </TableCell>
              </TableRow>
            }
            {(solicitudSeleccionada?.idEfectorGeneracion || practicaLabo) &&
              <TableRow>
                {solicitudSeleccionada?.idEfectorGeneracion &&
                  <>
                    <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                      Generada Por:
                    </TableCell>
                    <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                      {solicitudSeleccionada?.efectorGeneracion?.nombreEfector}
                    </TableCell>
                    <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                      Fecha Prescripción: {`${new Date(solicitudSeleccionada?.fechaPrescripcion)
                        .toLocaleString("es", optionsfecha)}`}
                    </TableCell>
                    <Tooltip title="Evulución">
                      <Button
                        style={{ marginTop: -5, marginLeft: 25 }}
                        onClick={() => {
                          // setEditProblema(problema);
                          setOpenModalProblema(true);
                          dispatch(TraerEvolucionesAfiliadoFecha(solicitudSeleccionada?.idAfiliado, solicitudSeleccionada?.fechaPrescripcion));
                        }}
                      >
                        <LocalHospitalSharp fontSize="large" />
                      </Button>
                    </Tooltip>
                    {openModalProblema &&
                      <ModalEvolucionesProblemas
                        open={openModalProblema}
                        close={() => {
                          setOpenModalProblema(false);
                        }}
                        titulo={'Evolucion Paciente Fecha Prescrpción'}
                        disabled={true}
                      />
                    }
                  </>
                }
                {practicaLabo &&
                  <>
                    <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                    </TableCell>
                    <TableCell style={{ borderBottom: "0", fontSize: "1rem" }}>
                      {practicaLabo?.turno?.efectorRed?.nombreEfector}
                    </TableCell>
                  </>
                }
              </TableRow>
            }
          </TableBody>
        </Table>
      }
      {solicitudSeleccionada?.diagnosticoEgreso && (
        <Table
          style={{ width: "80%", margin: "auto" }}
        >
          <TableBody>
            <TableRow>
              <TableCell
                style={{
                  borderBottom: "0",
                  fontSize: "1rem",
                  verticalAlign: "bottom",
                  position: "relative",
                  bottom: "2px",
                }}
              >
                Diagnostico de Egreso:
              </TableCell>
              <TableCell
                style={{ borderBottom: "0", fontSize: "1rem", width: "78%" }}
              >
                <AutoCompleteDiagnostico
                  disabled={disabled}
                  autoCompleteValue={solicitudSeleccionada.diagnosticoEgreso}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>)}
      <Grid style={{ margin: "0.5rem 0" }}>
        <Grid
          container
          spacing={2}
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "0.5rem",
          }}
        >
          {idTipoSolicitud === idTipoSolicitudPractica && (
            <React.Fragment>
              <Grid
                item
                xs={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <RadioGroup
                  row
                  value={conInternacionValue}
                  defaultValue={conInternacionValue}
                  onChange={(e) => {
                    dispatch(
                      updateSolicitud(
                        "conInternacion",
                        e.target.value === "internacion"
                      )
                    );
                    setConInternacionValue(e.target.value);
                    setearVariosValores({
                      conInternacion: e.target.value === "internacion",
                      idMotivoInternacion: "0",
                      fechaPrescripcion: "",
                      fechaProgramada: "",
                      telefono: "",
                      celular: "",
                    });
                  }}
                >
                  <FormControlLabel
                    value={"ambulatorio"}
                    control={<Radio />}
                    label="Ambulatoria"
                    disabled
                  />
                  <FormControlLabel
                    value={"internacion"}
                    control={<Radio />}
                    label="Con internación"
                    disabled
                  />
                </RadioGroup>
              </Grid>
              <React.Fragment>
                {conInternacion && (
                  <>
                    <Grid item xs={6}>
                      <MuiPickersUtilsProvider
                        locale={esLocale}
                        utils={DateFnsUtils}
                      >
                        <ValidatedDatePicker
                          fullWidth={true}
                          margin="normal"
                          format="dd/MM/yyyy"
                          okLabel="Aceptar"
                          disabled={disabled}
                          clearLabel="Limpiar"
                          cancelLabel="Cancelar"
                          label="Fecha Prescripción"
                          name="fechaPrescripcion"
                          value={
                            fechaPrescripcion !== undefined &&
                              moment(fechaPrescripcion).isValid()
                              ? moment(fechaPrescripcion)
                              : null
                          }
                          onChange={(e) => {
                            setearValor("fechaPrescripcion", e);
                            dispatch(
                              updateSolicitud("fechaPrescripcion", moment(e))
                            );
                          }}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                          maxDate={new Date()}
                          validators={
                            practicaElegida?.requiereFechaPrescripcion && [
                              "required",
                              "isAfterToday",
                            ]
                          }
                          errorMessages={
                            practicaElegida?.requiereFechaPrescripcion && [
                              "La fecha de prescripción es requerida",
                              "La fecha de prescripción no puede ser mayor a la fecha actual",
                            ]
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6}>
                      <MuiPickersUtilsProvider
                        locale={esLocale}
                        utils={DateFnsUtils}
                      >
                        <ValidatedDatePicker
                          fullWidth={true}
                          margin="normal"
                          format="dd/MM/yyyy"
                          okLabel="Aceptar"
                          disabled={disabled}
                          clearLabel="Limpiar"
                          cancelLabel="Cancelar"
                          label="Fecha Programada"
                          name="fechaProgramada"
                          value={
                            fechaProgramada !== undefined &&
                              moment(fechaProgramada).isValid()
                              ? moment(fechaProgramada)
                              : null
                          }
                          onChange={(e) => {
                            setearValor("fechaProgramada", e);
                            dispatch(
                              updateSolicitud("fechaProgramada", moment(e))
                            );
                          }}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                          minDate={fechaPrescripcion}
                          validators={
                            practicaElegida?.requiereFechaProgramada && [
                              "required",
                              "isBeforeFechaPrescripcion",
                            ]
                          }
                          errorMessages={
                            practicaElegida?.requiereFechaProgramada && [
                              "La fecha programada es requerida",
                              "La fecha programada no puede ser menor a la fecha fecha de prescripción",
                            ]
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                  </>
                )}
                <Grid
                  item
                  xs={12}
                  style={{ marginTop: "1rem", marginLeft: "1rem" }}
                >
                  <FormControl>
                    <FormLabel>Motivo de internación:</FormLabel>
                    <RadioGroup
                      value={idMotivoInternacion?.toString()}
                      defaultValue={idMotivoInternacion?.toString()}
                      onChange={(e) => {
                        //setearValor("idMotivoInternacion", e.target.value);
                        setearVariosValores({
                          idMotivoInternacion: e.target.value,
                          telefono: e.target.value === "4" ? "" : telefono,
                          celular: e.target.value === "4" ? "" : celular,
                        });

                        dispatch(
                          updateSolicitud(
                            "idMotivoInternacion",
                            parseInt(e.target.value)
                          )
                        );
                      }}
                    >
                      <FormControlLabel
                        value={"1"}
                        control={<Radio />}
                        disabled={disabled}
                        label="Accidente en via pública"
                      />
                      <FormControlLabel
                        value={"2"}
                        control={<Radio />}
                        disabled={disabled}
                        label="Accidente de trabajo"
                      />
                      <FormControlLabel
                        value={"3"}
                        control={<Radio />}
                        disabled={disabled}
                        label="Otro tipo de accidente con denuncia policial"
                      />
                      <FormControlLabel
                        value={"4"}
                        control={<Radio />}
                        disabled={disabled}
                        label="Ninguno"
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                {idMotivoInternacion && parseInt(idMotivoInternacion) < 4 && (
                  <React.Fragment>
                    <Grid item xs={6}>
                      <TextValidator
                        fullWidth
                        margin="normal"
                        disabled={disabled}
                        label="Tel. Particular(10 dígitos sin el 0)"
                        name="telefono"
                        value={telefono}
                        onChange={(e) => {
                          handleInputChange(e);
                          dispatch(
                            updateSolicitud(
                              "telefono",
                              parseInt(e.target.value)
                            )
                          );
                        }}
                        validators={
                          celular === ""
                            ? [
                              "required",
                              "isNumber",
                              "maxNumber:9999999999",
                              "minNumber:999999999",
                            ]
                            : [
                              "isNumber",
                              "maxNumber:9999999999",
                              "minNumber:999999999",
                            ]
                        }
                        errorMessages={
                          celular === ""
                            ? [
                              "El teléfono es requerido",
                              "Sólo números",
                              "Verifique su teléfono",
                              "Verifique su teléfono",
                            ]
                            : [
                              "Sólo números",
                              "Verifique su teléfono",
                              "Verifique su teléfono",
                            ]
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextValidator
                        fullWidth
                        margin="normal"
                        disabled={disabled}
                        label="Tel. Celular(10 dígitos sin 0 ni 15)"
                        name="celular"
                        value={celular}
                        onChange={(e) => {
                          handleInputChange(e);
                          dispatch(
                            updateSolicitud(
                              "celular",
                              parseInt(e.target.value)
                            )
                          );
                        }}
                        maxLength="10"
                        validators={
                          telefono === ""
                            ? [
                              "required",
                              "isNumber",
                              "maxNumber:9999999999",
                              "minNumber:999999999",
                            ]
                            : [
                              "isNumber",
                              "maxNumber:9999999999",
                              "minNumber:999999999",
                            ]
                        }
                        errorMessages={
                          telefono === ""
                            ? [
                              "El celular es requerido",
                              "Sólo números",
                              "Verifique su celular",
                              "Verifique su celular",
                            ]
                            : [
                              "Sólo números",
                              "Verifique su celular",
                              "Verifique su celular",
                            ]
                        }
                      />
                    </Grid>
                  </React.Fragment>
                )}
              </React.Fragment>
            </React.Fragment>
          )}
          {(idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION ||
            idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA) && (
              <React.Fragment>
                <Grid item xs={4}>
                  <MuiPickersUtilsProvider
                    locale={esLocale}
                    utils={DateFnsUtils}
                  >
                    <ValidatedDatePicker
                      fullWidth={true}
                      disabled={true}
                      margin="normal"
                      format="dd/MM/yyyy"
                      okLabel="Aceptar"
                      clearLabel="Limpiar"
                      cancelLabel="Cancelar"
                      label="Fecha Ingreso"
                      name="fechaIngreso"
                      value={
                        fechaIngreso !== undefined &&
                          moment(fechaIngreso).isValid()
                          ? moment(fechaIngreso)
                          : null
                      }
                      onChange={(e) => {
                        setearValor("fechaIngreso", e);
                        dispatch(
                          updateSolicitud("fechaIngreso", moment(e))
                        );
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      maxDate={new Date()}
                    /* validators={
                      practicaElegida?.requiereFechaPrescripcion && [
                        "required",
                        "isAfterToday",
                      ]
                    }
                    errorMessages={
                      practicaElegida?.requiereFechaPrescripcion && [
                        "La fecha de prescripción es requerida",
                        "La fecha de prescripción no puede ser mayor a la fecha actual",
                      ]
                    } */
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={4}>
                  <MuiPickersUtilsProvider
                    locale={esLocale}
                    utils={DateFnsUtils}
                  >
                    <ValidatedDatePicker
                      fullWidth={true}
                      disabled={true}
                      margin="normal"
                      format="dd/MM/yyyy"
                      okLabel="Aceptar"
                      clearLabel="Limpiar"
                      cancelLabel="Cancelar"
                      label={idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION
                        ? "Fecha Egreso"
                        : "Fecha Alta"
                      }
                      name="fechaEgreso"
                      value={
                        fechaEgreso !== undefined &&
                          moment(fechaEgreso).isValid()
                          ? moment(fechaEgreso)
                          : null
                      }
                      onChange={(e) => {
                        setearValor("fechaEgreso", e);
                        dispatch(
                          updateSolicitud("fechaEgreso", moment(e))
                        );
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      minDate={fechaPrescripcion}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                {idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
                  <Grid item xs={4}>
                    <TextValidator
                      fullWidth
                      margin="normal"
                      disabled={disabled}
                      label="Motivo Cierre Internacion"
                      name="formValues.motivoCierreInternacionDomiciliaria.descripcion"
                      value={formValues.motivoCierreInternacionDomiciliaria?.descripcion}
                    />
                  </Grid>
                }
                <Grid item xs={4}>
                  {Array.isArray(sectoresInternacion) &&
                    sectoresInternacion.length > 0 && (
                      <SelectValidator
                        fullWidth
                        margin="normal"
                        label="Sectores"
                        name="idSector"
                        value={idSector}
                        disabled={disabled}
                        onChange={(e) => {
                          setearValor("idSector", e.target.value);
                          dispatch(
                            updateSolicitud("idSector", e.target.value)
                          );
                        }}
                        validators={["required"]}
                        errorMessages={["Este campo es requerido"]}
                      >
                        {sectoresInternacion.map((sector) => (
                          <MenuItem key={sector.idSector} value={sector.idSector}>
                            {sector.descripcionSector}
                          </MenuItem>
                        ))}
                      </SelectValidator>
                    )}
                </Grid>
              </React.Fragment>
            )}
          {solicitudSeleccionada?.fromAppMobile && (
            <Table
              style={{ width: "80%", margin: "auto" }}
            >
              <TableBody>
                <TableRow>
                  <TableCell
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Creada desde la APP
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>)}
        </Grid>
        <InformacionDocumentacion
          disabled={desdeBandejaSurge === true ? false : disabled}
          setFaltaDocumentacion={setFaltaDocumentacion}
          filtros={props.filtros}
        />
        <div style={{ textAlign: "center", marginTop: "2.5rem" }}>
          <Button variant="contained" color="primary" disabled={disabled} type="submit">
            Guardar Cambios
          </Button>
        </div>
      </Grid>
    </ValidatorForm>
  );
};
